// Náklady pred vyúčtovaním RD + priebežný zisk (ústava 122.7, Mirko 27. 9. 2026)
// Office pred vyúčtovaním potvrdí VSZAK a VSOST, zapíše mzdy a výmery, nahrá protokol od omietkára a klikne Potvrdiť náklady.
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'   // mzda_ukoncena_v1: z chýbajúcej položky sa dá ísť tam, kde sa doplní
import { fetchAuth } from '../auth/fetchAuth.js'
import { Btn } from './Btn.jsx'
import { Modal } from './Modal.jsx'
import { useToast } from './Toast.jsx'
import AttachmentsPanel from './AttachmentsPanel.jsx'
import { COLORS, TYPO, SPACE, RADIUS, SK } from '../theme.js'

export function useRdZiskovost(projectId, aktivne) {
  const [rz, setRz] = useState(null)
  const nacitaj = () => fetchAuth('/api/rd-ziskovost/' + encodeURIComponent(projectId)).then(r => r.ok ? r.json() : null).then(setRz).catch(() => setRz(null))
  useEffect(() => { if (aktivne) nacitaj() }, [projectId, aktivne])   // eslint-disable-line
  // mzda_ukoncena_v1 (8. 10. 2026): stav sa načítal raz a potom už len po zatvorení okna s protokolom.
  // Keď prílohu nahral NIEKTO INÝ (8. 10. nahrala protokol Lucia o 08:46), otvorená obrazovka ďalej
  // ukazovala „✗ Protokol od omietkára nahratý“ — a vyzeralo to, že protokol tam nie je. Preto sa
  // stav obnoví vždy, keď sa človek vráti na okno alebo na kartu prehliadača.
  useEffect(() => {
    if (!aktivne) return
    const obnov = () => { if (!document.hidden) nacitaj() }
    window.addEventListener('focus', obnov)
    document.addEventListener('visibilitychange', obnov)
    return () => { window.removeEventListener('focus', obnov); document.removeEventListener('visibilitychange', obnov) }
  }, [projectId, aktivne])   // eslint-disable-line
  return [rz, nacitaj]
}

// mzda_ukoncena_v1 (8. 10. 2026, Mirko: „jedno vylučuje druhé… už sa hanbím pre office, nikdy to nejde“):
// zoznam chýbajúcich vecí bol slepá ulica — povedal ČO chýba, ale nie KDE sa to doplní. Odteraz má každá
// chýbajúca položka tlačidlo na to miesto, kde sa doplní (ústava 66: kde sa dá niečo urobiť, stojí tam tlačidlo).
// odkazy_v1 (nočný čitateľ 13./14. 10. 2026): Router beží s basename="/v2", takže '/v2/...' tu vyrobilo
// cestu /v2/v2/... , tú zachytilo pravidlo path="*" a človeka to vyhodilo na Môj deň. Presne tie dva odkazy,
// ktoré Mirko 8. 10. žiadal doplniť, aby zoznam chýbajúcich vecí nebol slepá ulička, teda nikam neviedli.
const KAM = {
  mzdy: { text: 'Zapísať mzdy', kam: (pid) => '/mzdy2026?zakazka=' + encodeURIComponent(pid) },
  vszak_vsost: { text: 'Otvoriť Výdavky', kam: (pid) => '/zakazky/' + encodeURIComponent(pid) },
}
const odkaz = { background: 'none', border: 0, padding: 0, font: 'inherit', color: '#1B4A5A', textDecoration: 'underline', cursor: 'pointer' }

export default function RdZiskovost({ projectId, rz, nacitaj, onChanged }) {
  const toast = useToast()
  const navigate = useNavigate()
  const [pracuje, setPracuje] = useState(false)
  const [dok, setDok] = useState(false)
  if (!rz) return null
  const k = rz.kontrola
  const fmt = (d) => { if (!d) return ''; const [y, m, dd] = String(d).slice(0, 10).split('-'); return Number(dd) + '. ' + Number(m) + '. ' + y }
  const potvrd = async (zrus) => {
    setPracuje(true)
    try {
      const r = await fetchAuth('/api/rd-ziskovost/' + encodeURIComponent(projectId) + (zrus ? '/zrusit-potvrdenie' : '/potvrdit'), { method: 'POST' })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) { toast.error(j.error || 'Nepodarilo sa.'); return }
      toast.success(zrus ? 'Potvrdenie nákladov zrušené.' : 'Náklady potvrdené — vyúčtovanie sa dá vyrobiť.'); nacitaj(); onChanged && onChanged()
    } catch (e) { toast.error(e.message) } finally { setPracuje(false) }
  }
  return (
    <div style={{ marginTop: 8, border: `1px solid ${k.pripravene ? '#bbf7d0' : COLORS.line}`, background: k.pripravene ? '#f0fdf4' : COLORS.bgSoft, borderRadius: RADIUS.md, padding: '8px 12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
        <b style={{ fontSize: TYPO.sizes.sm }}>Náklady pred vyúčtovaním</b>
        <span style={{ fontSize: TYPO.sizes.xs, color: k.pripravene ? '#15803d' : '#b45309', fontWeight: 700 }}>
          {/* vyuct_nic_v2 (8. 10. 2026): toto je prehľad, nie zákaz — vyúčtovanie nezastaví ani jedna z týchto položiek. */}
          {k.pripravene ? 'potvrdené ' + fmt(k.potvrdene_at) + (k.potvrdene_by ? ' · ' + k.potvrdene_by : '') : k.chyba.length ? 'ešte sa dopĺňa (' + k.chyba.length + ') — vyúčtovanie to nezastaví' : 'všetko doplnené — treba potvrdiť'}
        </span>
        <span style={{ flex: 1 }} />
        <Btn size="sm" onClick={() => setDok(true)}>Protokol od omietkára ({k.polozky.find(p => p.kod === 'protokol') && k.polozky.find(p => p.kod === 'protokol').ok ? 'nahratý' : 'nahrať'})</Btn>
        {/* vyuct_nic_v2: tlačidlo už nie je zamknuté. Potvrdenie nákladov je vyhlásenie office, že náklady
            sedia — nie povolenie vyúčtovať. Vyúčtovanie ide aj bez neho (Mirko 8. 10. 2026). */}
        {rz.smie && !k.potvrdene && <Btn size="sm" variant="add" onClick={() => potvrd(false)} loading={pracuje} title={k.chyba.length ? 'Potvrdíš, že náklady sedia. Vyúčtovanie na to nečaká — ide aj bez potvrdenia.' : 'Potvrdíš, že náklady sedia.'}>Potvrdiť náklady</Btn>}
        {rz.smie && k.potvrdene && <Btn size="sm" onClick={() => potvrd(true)} loading={pracuje}>Zrušiť potvrdenie</Btn>}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '2px 14px', marginTop: 6, fontSize: TYPO.sizes.xs }}>
        {k.polozky.map(p => (
          /* vyuct_nic_v2: nič z tohto zoznamu už doklad nezastaví, takže sa nič nekreslí ako chyba. */
          <div key={p.kod} style={{ color: p.ok ? COLORS.text : COLORS.muted }}>
            {/* mzda_ukoncena_v1: čo doklad nezastaví (`nebrani`), sa nekreslí červeno — nie je to chyba, je to poradie práce */}
            <b>{p.ok ? '✓' : '·'} {p.nazov}</b> <span style={{ color: COLORS.muted }}>— {p.info}</span>
            {!p.ok && p.kod === 'protokol' && <> <button type="button" onClick={() => setDok(true)} style={odkaz}>Nahrať protokol</button></>}
            {!p.ok && KAM[p.kod] && <> <button type="button" onClick={() => navigate(KAM[p.kod].kam(projectId))} style={odkaz}>{KAM[p.kod].text}</button></>}
          </div>
        ))}
      </div>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4 }}>
        <b>Vyúčtovanie nie je podmienené ničím</b> — ani výdavkami, ani odoslanou cenovou ponukou, ani výdajkou, ani mzdami
        (ústava 122.7 v znení z 8. 10. 2026). Tento zoznam je prehľad, čo ešte chýba; doklad nezastaví.
        Mzdy sa zapisujú až po vyúčtovaní.
      </div>
      {k.potvrdene && k.chyba.length > 0 && <div style={{ fontSize: TYPO.sizes.xs, color: '#b45309', marginTop: 4 }}>Po potvrdení pribudli nové nepotvrdené doklady alebo niečo chýba — skontroluj a potvrď znova.</div>}
      <Modal open={dok} onClose={() => { setDok(false); nacitaj() }} title="Protokol od omietkára" subtitle="Nahraj protokol (výmery), ktorý poslal omietkár." width="min(720px, 95vw)">
        {dok && <AttachmentsPanel entityType={k.protokol_typ} entityId={projectId} showPhase={false} onChanged={nacitaj} />}
      </Modal>
    </div>
  )
}

export const eurZisk = (n) => SK.eur(n || 0)
